function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-949.000000, -59.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Upload-button",
  transform: "translate(817.000000, 42.000000)"
}, React.createElement("path", {
  d: "M135.324598,21.809228 L140.972523,27.6413838 C141.423361,28.1064205 142.169129,28.1211056 142.638241,27.6741839 C143.107353,27.2272622 143.122167,26.4879739 142.671328,26.0229372 C142.370769,25.7129128 140.75042,24.038602 137.810279,21.0000047 C140.75042,17.9614012 142.370769,16.2870872 142.671328,15.9770628 C143.122167,15.5120261 143.107353,14.7727378 142.638241,14.3258161 C142.169129,13.8788944 141.423361,13.8935795 140.972523,14.3586162 L135.324598,20.190772 C135.104537,20.4198457 134.987754,20.7276904 135.001018,21.0437458 C135.010569,21.3296015 135.125723,21.6020178 135.324598,21.809228 Z",
  id: "Path",
  transform: "translate(139.000000, 21.000000) rotate(-90.000000) translate(-139.000000, -21.000000) "
}))));

const SvgAngleDown = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAngleDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/angle-down.9ab35d8e.svg";
export { ForwardRef as ReactComponent };